import { useEffect, useState } from 'react';

const DEFAULT_ROTATION_DELAY_MS = 5000;

export function useAutoRotatingIndex(length: number, enabled = true, delayMs = DEFAULT_ROTATION_DELAY_MS) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (length === 0) {
      if (currentIndex === 0) return;
      setCurrentIndex(0);
      return;
    }
    if (currentIndex < length) return;
    setCurrentIndex(0);
  }, [currentIndex, length]);

  useEffect(() => {
    if (typeof window === 'undefined' || !enabled || length < 2) return;
    const timer = window.setTimeout(() => {
      setCurrentIndex(index => (index + 1) % length);
    }, delayMs);
    return () => window.clearTimeout(timer);
  }, [currentIndex, delayMs, enabled, length]);

  return { currentIndex, setCurrentIndex, hasMultipleItems: length > 1 };
}
